import { z } from 'zod';

export const LOG_SYNC_EVENT_CHANNEL = 'log-sync-event';

export const SyncEventSchema = z.object({
  level: z.enum(['info', 'warn', 'error']),
  context: z.string().max(80),
  message: z.string().max(200),
  sync_request_id: z.string().max(64).optional(),
  metadata: z
    .record(
      z.string(),
      z.union([z.string(), z.number(), z.boolean(), z.null()])
    )
    .optional(),
});
export type SyncEvent = z.infer<typeof SyncEventSchema>;
